import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { InventoryFormItem } from "./InventoryItemForm"

export const INVENTORY_ITEM_FORM_SUBMITTED = "inventoryItem/form/submitted"

export const inventoryItemFormSubmitted = (
    oldValue: Maybe<InventoryFormItem>,
    newValue: InventoryFormItem,
    locationIds: string[],
    itemIds: string[]
) => ({
    type: INVENTORY_ITEM_FORM_SUBMITTED,
    payload: {
        oldValue: oldValue,
        newValue: newValue,
        locationIds: locationIds,
        itemIds: itemIds,
    },
})

export const DELETE_INVENTORY_ITEM_CLICKED = "inventoryItem/delete/clicked"

export const deleteInventoryItemClicked = (id: string) => ({
    type: DELETE_INVENTORY_ITEM_CLICKED,
    payload: {
        id: id,
    },
})

export const DELETE_INVENTORY_ITEM_LOCATION_CLICKED = "inventoryItemLocation/delete/clicked"

export const deleteInventoryItemLocationClicked = (invItemLocationId: string, invItemId: string) => ({
    type: DELETE_INVENTORY_ITEM_LOCATION_CLICKED,
    payload: {
        invItemLocationId: invItemLocationId,
        invItemId: invItemId,
    },
})

export const CLOSE_INVENTORY_ITEM_FORM_CLICKED = "inventoryItem/close/clicked"

export const closeInventoryItemFormClicked = () => ({
    type: CLOSE_INVENTORY_ITEM_FORM_CLICKED,
})

export const INVENTORY_STOCKING_MODAL_TOGGLE_CLICKED = "inventory/stockingModal/toggle/clicked"

export const inventoryStockingModalToggleClicked = (inventoryItemId: string) => ({
    type: INVENTORY_STOCKING_MODAL_TOGGLE_CLICKED,
    payload: {
        inventoryItemId: inventoryItemId,
    },
})

export const INVENTORY_STOCKING_MODAL_FORM_SUBMITTED = "inventory/stockingModal/form/submitted"

export const inventoryStockingModalFormSubmitted = (locationId: string, inventoryItemId: string, count: number) => ({
    type: INVENTORY_STOCKING_MODAL_FORM_SUBMITTED,
    payload: {
        locationId: locationId,
        inventoryItemId: inventoryItemId,
        count: count,
    },
})
// Inventory Stocking drawer

export const CLOSE_INVENTORY_STOCKING_FORM_CLICKED = "inventory/stocking/close/clicked"

export const closeInventoryStockingFormClicked = () => ({
    type: CLOSE_INVENTORY_STOCKING_FORM_CLICKED,
})
// Log of Changes

export const LOG_OF_CHANGES_LOCATION_CHANGED = "inventory/logOfChange/location/changed"

export const logOfChangesLocationChanged = (locationId: Maybe<string>, inventoryItemId: string) => ({
    type: LOG_OF_CHANGES_LOCATION_CHANGED,
    payload: {
        locationId: locationId,
        inventoryItemId: inventoryItemId,
    },
})
// Search

export const INVENTORY_SEARCH_CLICKED = "inventory/search/clicked"

export const inventorySearchClicked = (pattern: Maybe<string>) => ({
    type: INVENTORY_SEARCH_CLICKED,
    payload: {
        pattern: pattern,
    },
})

export const INVENTORY_FETCH_REQUESTED = "inventory/fetch/requested"

export const inventoryFetchRequested = () => ({
    type: INVENTORY_FETCH_REQUESTED,
})
